import { apps } from "./apps"

export const getLabelTextWithValue = (types, val) => {
  const it = types.find(t => t.value === val)
  return it ? it.label : ''
}

/**
 * 搜索选项
 */
export const toggleOptions = [
  { label: '是', value: true },
  { label: '否', value: false },
]

/**
 * 搜索选项
 */
export const tranTypeOptions = [
  { label: 'AI女友聊天', value: 1 },
]

export const roleTagTypes = [
  { label: '性格', value: 'personality' },
  { label: '兴趣爱好', value: 'hobby' },
  { label: '外貌', value: 'appearance' },
]

export const genderTypes = [
  { label: '男性', value: 'male' },
  { label: '女性', value: 'female' },
  { label: '卡通', value: 'animate' },
]

export const appOptions = apps.map(app => ({ label: app.name, value: app.appId }))


export const modelOptions = ['grok-3', 'deepseek-r1', 'gemini-1.5-pro', 'qwq-32b'].map(nm => ({ label: nm, value: nm }))